<template>
    <div class="query-record-list">
        <ab-list-query>
            <template #right>
                <el-row :gutter="20">
                    <el-col :span="4">
                        <el-input placeholder="请输入供应商" v-model.trim="formSearch.supplierName" clearable></el-input>
                    </el-col>
                    <el-col :span="4">
                        <el-input  placeholder="请输入操作人" v-model.trim="formSearch.createByName" clearable></el-input>
                    </el-col>
                    <el-col :span="4">
                        <ab-timeSearch
                            class="searchBox"
                            startSrc="查询时间起"
                            endSrc="查询时间止"
                            v-model="formSearch.updateTimeArr"
                            @searchEvent="changeTimeRange"
                        ></ab-timeSearch>
                    </el-col>
                    <el-col :span="4" class="text-left">
                        <el-button @click="searchForm">搜索</el-button>
                        <el-button link class="btn-svg" @click="formSearch = {}"><ab-svg name="qingchu"></ab-svg>清除</el-button>
                    </el-col>
                </el-row>
            </template>

            <template #toolbar>
                <el-button type="primary" @click="exportFile" :loading="load.exportLoading">批量下载</el-button>
            </template>

            <template #table>
                <ab-table
                    class="materialTable"
                    ref="table"
                    stripe
                    showEdit
                    showSelection
                    selectionWidth="45"
                    indexWidth="50"
                    widths="120"
                    isFilter="operator"
                    :column-list="columns"
                    :table-list="tableData"
                    :dataListLoading="load.isloading"
                    @filterColumns="filterColumns"
                    :handleSelectionChange="handleSelectionChange"
                >
                    <template #operator="scope">
                        <el-button type="primary" link :loading="load.cancelLoading" @click="download(scope.row)">下载库存</el-button>              
                    </template>
                </ab-table>
                
            </template>

            <template #page>
                <ab-page
                    :pageTotal="page.total" 
                    :currentPage='page.currentPage' 
                    :pageSize="page.pageSize" 
                    :pageSizes="page.pageSizes"
                    @searchForm="pageSearch"
                ></ab-page>
            </template>
        </ab-list-query>
    </div>
</template>

<script>
export default {
    name: 'query-record-list',
    data() {
        return {
            formSearch: {},
            load:{
                exportLoading: false,
                cancelLoading: false
            },
            selectArr: [],
            columns: [
                {
                    props: 'supplierName',
                    labels: '供应商',
                    widths: 120,
                },
                {
                    props: 'sendEmail',
                    labels: '发送邮箱',
                    widths: 80,
                },
                {
                    props: 'createByName',
                    labels: '操作人 ',
                    widths: 120,
                },
                {
                    props: 'createTime',
                    labels: '查询时间',
                    widths: 50
                },
            ],
            tableData: [],
            page: {
                currentPage: 1,
                pageSize: 10,
                pageSizes: [10, 20, 50, 100],
                total: 0
            }
        }
    },
    mounted() {
        this.getDataList()
    },
    methods:{
        filterColumns(val){  
            this.columns=val
        },
        getDataList(){
            this.load.isloading = true
            let params = Object.assign({}, {data: this.formSearch}, {pageNum: this.page.currentPage, pageSize: this.page.pageSize})
            this.$post('/bigdata/spiderStock/list', params).then(({ data }) => {
                if (data.result && data.code === 'C0000') {
                    this.tableData = data.result.list
                    this.page.total = data.result.total
                }
            }).finally(() => {
                this.load.isloading = false
            })
        },
        searchForm(){
            this.getDataList()
        },
        //日期
        changeTimeRange(obj){
            if (obj) {
                this.formSearch.createTimeStart = obj[0];
                this.formSearch.createTimeEnd = obj[1];
            } else {
                this.formSearch.createTimeStart = "";
                this.formSearch.createTimeEnd = "";
            }
        },
        //翻页
        pageSearch(obj) {
            this.page.currentPage = obj.currentPage;
            this.page.pageSize = obj.pageSize;
            this.getDataList();
        },
        //批量下载
        exportFile(){
            this.load.exportLoading = true
            let selectArr
            let url
            
            if(this.selectArr.length){
                selectArr = this.selectArr
                url = '/bigdata/spiderStock/batchExport'
            }else{
                selectArr = this.formSearch
                url = '/bigdata/spiderStock/export'
            }
            this.$http({
                url: this.$adornUrl(url),
                method: 'post',
                data: selectArr,
                responseType: 'arraybuffer'
            }).then(res => {
                let data
                if(!res.headers.filename){
                    let time = new Date()
                    data = `${time.getFullYear()}${(time.getMonth() + 1) < 10? '0' + (time.getMonth() + 1) : time.getMonth() + 1}${time.getDate() < 10? '0' + time.getDate() : time.getDate()}${time.getHours() < 10? '0' + time.getHours() : time.getHours()}${time.getMinutes() <10? '0'+ time.getMinutes() : time.getMinutes()}${time.getSeconds() < 10? '0' + time.getSeconds() : time.getSeconds()}`
                    
                }
                const blob = new Blob([res.data], { type: 'application/vnd.ms-excel'})
                const filename = decodeURIComponent(res.headers.filename  || data)
                const link = document.createElement('a')
                link.href = URL.createObjectURL(blob)
                link.download = filename
                document.body.appendChild(link)
                link.click()
                window.setTimeout(function () {
                    URL.revokeObjectURL(blob)
                    document.body.removeChild(link)
                }, 0)
            }).finally(() => {
                this.load.exportLoading = false
            })
        },
        //单个数据下载
        download(row){
            if(row.excelUrl){
                let eleLink = document.createElement('a')
                eleLink.download = ''
                eleLink.style.display = 'none'
                eleLink.target = '_blank'
                // 字符内容转变成blob地址
                eleLink.href = row.excelUrl
                // 触发点击
                document.body.appendChild(eleLink)
                eleLink.click()
                // 然后移除
                document.body.removeChild(eleLink)
            }else{
                this.$message({
                    type: 'error',
                    message: '暂无该供应商库存数据',
                    offset: 380,
                    grouping: true,
                })
            }
        },
        handleSelectionChange(val){
            this.selectArr = val
        }
    }
}
</script>

<style lang="scss">
    .query-record-list{
        .el-menu.el-menu--horizontal{
            display: none;
        }
    }
</style>